import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from 'store';
import { ChatUserLabel } from 'types/chat-users/chat-user-label';
import { fetcher } from 'utils/axios';

const initialState: ChatUserLabel[] = [];
const labelsSlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setLabelsList(state, action: PayloadAction<ChatUserLabel[]>) {
      return action.payload;
    },
    resetLabelsList() {
      return initialState;
    },
  },
});

export default labelsSlice.reducer;
export const { setLabelsList, resetLabelsList } = labelsSlice.actions;

export async function getCompanyLabelsList() {
  try {
    const data = await fetcher('get', '/api/services/GetCompanyLabelsList', 'history');
    let labelsList: ChatUserLabel[] = [];
    if (data.labelsList.labelsList && data.labelsList.labelsList.length) {
      const newLabelsList = JSON.parse(data.labelsList.labelsList);
      labelsList = [
        {
          //TODO
          name: 'noLabel', //! IF name = noLabel, then it should be translated as "noLabel"
          color: '#2a3847',
        },
        ...newLabelsList,
      ];
    } else {
      labelsList = [
        {
          name: 'noLabel',
          color: '#2a3847',
        },
      ];
    }

    dispatch(setLabelsList(labelsList));
  } catch (error) {
    console.warn('getCompanyData err: ', error);
  }
}

export async function fetchUpdateLabelsList(
  oldLabelName: string | null = null,
  oldLabelColor: string | null = null,
  newLabelName: string | null = null,
  newLabelColor: string | null = null,
  updateType: 'add-new' | 'update' | 'delete',
  isActive = true,
) {
  try {
    const params = {
      OldLabelName: oldLabelName,
      OldLabelColor: oldLabelColor,
      NewLabelName: newLabelName,
      NewLabelColor: newLabelColor,
      isActive,
    };
    let data: { newArray?: string; result?: boolean } | null = null;
    
    if (updateType === 'add-new') {
      data = await fetcher('post', ['/api/services/AddNewChatLabel', { data: params }], 'history');
    } else if (updateType === 'delete') {
      data = await fetcher('post', ['/api/services/DeleteChatLabel', { data: params }], 'history');
    } else if (updateType === 'update') {
      data = await fetcher('post', ['/api/services/UpdateChatLabel', { data: params }], 'history');
    }
    
    console.log('📋 fetchUpdateLabelsList response:', data);
    console.log('📋 updateType:', updateType);
    
    // If data is null (server error), reload the list to check if operation succeeded
    if (data === null) {
      console.log('⚠️ Server returned error, reloading labels list to verify...');
      // Wait a bit for server to process
      await new Promise(resolve => setTimeout(resolve, 500));
      // Reload the labels list from server
      await getCompanyLabelsList();
      // Consider it a success since we reloaded the list
      // (if it actually failed, the item will still be there)
      return true;
    }
    
    console.log('📋 data.newArray:', data.newArray);
    console.log('📋 data.result:', data.result);
    
    // If we got newArray, the operation succeeded (update the state)
    if (data.newArray) {
      try {
        const parsedArray = JSON.parse(data.newArray);
        dispatch(
          setLabelsList([
            {
              name: 'noLabel',
              color: '#2a3847',
            },
            ...parsedArray,
          ]),
        );
        console.log('✅ Labels list updated successfully');
        // If we got newArray and successfully parsed it, consider it a success
        return true;
      } catch (parseError) {
        console.error('❌ Failed to parse newArray:', parseError);
        return false;
      }
    }
    
    // If no newArray but result is true, still consider it success
    if (data.result === true) {
      console.log('✅ Operation succeeded (result=true, no newArray)');
      return true;
    }
    
    // Otherwise, it failed
    console.log('❌ Operation failed');
    return false;
  } catch (e) {
    console.error('❌ fetchUpdateLabelsList error:', e);
    // In case of error, reload the list to check current state
    console.log('⚠️ Reloading labels list after error...');
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      await getCompanyLabelsList();
      return true; // Consider success since we reloaded
    } catch (reloadError) {
      console.error('❌ Failed to reload labels list:', reloadError);
      return false;
    }
  }
}
